import React from 'react';
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";

export default function AccountStatus({state}) {
    const { t } = useTranslation();

    function SwitchCase(props) {
        switch(props.value) {
            case 'temporaryHold':
                return <Typography color="danger.main">{t('account.status.temporaryHold')}</Typography>;
            case 'hold':
                return <Typography color="danger.main">{t('account.status.hold')}</Typography>;
            case 'ban':
                return <Typography color="danger.main">{t('account.status.ban')}</Typography>;
            default:
                return <Typography color="success.main">{t('account.status.activated')}</Typography>;
        }
    }

    return(
        <SwitchCase value={state} />
    )
}